import 'ng-sortable';

import discountRoutes from './discount.routes';

import discountListController from './controllers/discount.list.controller';
import discountSaveController from './controllers/discount.save.controller';
import discountFormController from './controllers/discount.form.controller';
import discountPeriodFormController from './controllers/discount.period.form.controller';
import membershipDiscountController from './controllers/membershipDiscount.controller';

import discountListComponent from './components/discount.list.component';
import discountSaveComponent from './components/discount.save.component';
import discountFormComponent from './components/discount.form.component';
import discountPeriodFormComponent from './components/discount.period.form.component';
import membershipDiscountComponent from './components/membershipDiscount.component';

import discountService from './services/discount.service';

let discountModule = angular.module('spabooker.discount', [ 'spabooker.base', 'as.sortable' ])
  .config(discountRoutes)

  .controller('discountListController', discountListController)
  .controller('discountSaveController', discountSaveController)
  .controller('discountFormController', discountFormController)
  .controller('discountPeriodFormController', discountPeriodFormController)
  .controller('membershipDiscountController', membershipDiscountController)

  .component('discountList', discountListComponent)
  .component('discountSave', discountSaveComponent)
  .component('discountForm', discountFormComponent)
  .component('discountPeriodForm', discountPeriodFormComponent)
  .component('membershipDiscount', membershipDiscountComponent)

  .factory('discountService', discountService)
;

export default discountModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/discounts/index.js